import { defineComponent as m, ref as l, computed as n, createElementBlock as a, openBlock as r, createElementVNode as u, createCommentVNode as f, toDisplayString as s, unref as p } from "vue";
import { useTruncateMiddle as x } from "../../../composables/useTruncateMiddle.js";
import { getExtension as _ } from "../Document.helpers.js";
const h = { "aria-hidden": "true" }, v = {
  key: 0,
  "aria-hidden": "true",
  class: "text-static-default-low body-1"
}, E = /* @__PURE__ */ m({
  __name: "DocumentName",
  props: {
    name: {}
  },
  setup(c) {
    const t = c, o = l(), e = n(() => _(t.name)), d = n(() => e.value ? `.${e.value}` : ""), { truncatedText: i } = x({
      elementRef: o,
      text: t.name,
      suffix: d
    });
    return (y, k) => (r(), a("div", {
      ref_key: "elementRef",
      ref: o,
      class: "text-static-default-hi body-1-bold grow overflow-hidden text-nowrap text-start"
    }, [
      u("span", h, s(p(i)), 1),
      e.value ? (r(), a("span", v, "." + s(e.value), 1)) : f("", !0)
    ], 512));
  }
});
export {
  E as default
};
